import React from 'react';

function Report () {
  return (
    <div className="main__content">
    <h1>Markdown is baking</h1>
  </div>  
  );
};

export default Report;